try {
            if (process.env.TOKENS_FEATURE_FLAG === 'true') require('./index-new.css');
            else require('./index.css');
          } catch (e) {
            if (e.code !== 'MODULE_NOT_FOUND') {
              throw e; // Re-throw unexpected errors
            }
            console.warn('index.css not found, proceeding without it.');
          }
          

import { jsxs, jsx } from 'react/jsx-runtime';
import { Container } from '@design-system/container';
import { HeadingBlock } from '@design-system/heading-block';
import { Section } from '@design-system/section';
import classNames from 'classnames';
import { forwardRef } from 'react';

const PageBlock = forwardRef(({ className, element = 'div', mode = 'default', maxWidth = 'full-width', heading, children, disableGutters, id, componentUid, }, ref) => (jsxs(Section, Object.assign({ ref: ref, mode: mode, element: element, className: classNames('cds-page-block', className), id: id, "data-component-uid": componentUid }, { children: [heading && (jsx(Container, Object.assign({ maxWidth: maxWidth }, { children: jsx(HeadingBlock, Object.assign({ className: "cds-page-block__heading" }, heading)) }))), jsx(Container, Object.assign({ disableGutters: disableGutters, className: "cds-page-block__content", maxWidth: maxWidth }, { children: children }))] }))));

export { PageBlock };
